// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomExpire = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.98622 15.9931C6.67152 15.9931 5.36752 15.6686 4.21467 15.0547C3.94517 14.9112 3.84322 14.5767 3.98724 14.3076C4.13125 14.0387 4.4667 13.9373 4.73602 14.0807C5.72881 14.6096 6.85279 14.8891 7.98622 14.8891C8.5188 14.8891 9.04941 14.8285 9.56292 14.709C9.86112 14.6396 10.1582 14.8242 10.2276 15.1212C10.2971 15.4182 10.1121 15.7151 9.81442 15.7843C9.21838 15.9229 8.60328 15.9931 7.98622 15.9931Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.84692 13.9529C2.71021 13.9529 2.5735 13.9028 2.46655 13.8016C1.33955 12.7365 0.551551 11.3823 0.187586 9.88549C0.115577 9.58922 0.297916 9.29063 0.595041 9.21879C0.891988 9.14695 1.19125 9.32905 1.26326 9.62532C1.57661 10.9148 2.25605 12.0817 3.22764 13.0001C3.44954 13.2097 3.45899 13.5592 3.24867 13.7806C3.13994 13.8951 2.99361 13.9529 2.84692 13.9529Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M0.554028 7.81493C0.535848 7.81493 0.517489 7.81404 0.498952 7.81226C0.194876 7.78238 -0.0273887 7.51208 0.00273373 7.20851C0.0914969 6.31294 0.32909 5.446 0.708918 4.63188C0.837963 4.35535 1.16699 4.23531 1.44416 4.36442C1.72114 4.49317 1.84127 4.82163 1.71223 5.09798C1.38498 5.799 1.18054 6.54573 1.10407 7.31717C1.07591 7.60206 0.835111 7.81493 0.554028 7.81493Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.88108 3.12906C2.75756 3.12906 2.63315 3.08799 2.53031 3.00369C2.29414 2.81021 2.25992 2.46219 2.45384 2.22674C2.50321 2.16663 2.5533 2.10741 2.60445 2.0489C2.80497 1.81896 3.15468 1.79478 3.38514 1.99538C3.6156 2.19562 3.63967 2.54435 3.43879 2.77429C3.39477 2.82461 3.35163 2.87583 3.30903 2.9274C3.19959 3.06024 3.04096 3.12906 2.88108 3.12906Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.8048 14.9467C11.6166 14.9467 11.4332 14.8509 11.3294 14.6782C11.1724 14.4166 11.2578 14.0775 11.52 13.921C13.5966 12.6804 14.8867 10.4116 14.8867 8.00003C14.8867 4.19776 11.7862 1.10435 7.97531 1.10435C7.66963 1.10435 7.42188 0.857158 7.42188 0.552174C7.42188 0.247189 7.66963 0 7.97531 0C12.3965 0 15.9934 3.58868 15.9934 7.99985C15.9934 10.7977 14.4971 13.4295 12.0884 14.8681C11.9994 14.9215 11.9016 14.9467 11.8048 14.9467Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.99506 12.3027C10.3741 12.3027 12.3026 10.3741 12.3026 7.99511C12.3026 5.61608 10.3741 3.6875 7.99506 3.6875C5.61606 3.6875 3.6875 5.61608 3.6875 7.99511C3.6875 10.3741 5.61606 12.3027 7.99506 12.3027ZM8.27147 7.72282H9.84324V8.27149H8.27147V9.84328H7.72281V8.27149H6.15104V7.72282H7.72281V6.15104H8.27147V7.72282Z',
      fill: 'currentColor',
    }),
  );

export { IconCustomExpire };
